<template>
	<div class="box" :style="widthStyle" >
		<div class="flex-row start top list-half">
			<el-upload v-show="showUpload && !uploading" :action="Url" :headers='Headers' list-type="text"
				:show-file-list="false" :on-success="onSuccess" :before-upload="onBeforeUpload"
				:disabled="disabled || config.Disabled"
		 
				 >
				<div class="video-box flex-column middle center" v-if="Data">
					<el-image :src="getFullPath(Data)" fit='cover' />
					<div class="fg f12">点击重新上传</div>
				</div>
				<div class="video-box flex-column middle center" v-else>
					<div class="flex-column center middle">
						<span style="font-size:32px;color:#666">+</span>
						<span class="fg f12" v-if='Show'>点击上传文件</span>
						<span class="fg f12">{{ Exts }}</span>
					</div>

				</div>

			</el-upload>
			<div @click="onDelete" v-if="Data" class="pointer">删除</div>
		</div>
		<div v-show="uploading" :style="ProcessStyle" class="flex-column center middle">
			<el-progress :stroke-width="16" :text-inside="true" :percentage="percentage"
				:color="config.Colors"></el-progress>
		</div>
	</div>
</template>
<script>
import upload from "./upload.js";
import base from "matrix.node.ui/field.js";
export default {
	mixins: [base.edit(String), upload],
	props: {
		value: String,
		config: Object
	},
	computed: {
		Show() {
			return this.config.ShowTitle === false ? false : true
		},
		Exts() {
			if (this.config.Exts) {
				return `请上传${this.config.Exts.join(",").replaceAll(".", '')}格式的图片`
			}
		}
	},
	 
};
</script>
<style scoped>
.box {
	width: 100%;
	text-align: left;

}

.video-box {
	width: 211px;
	height: 112px;
	background: #f7f8f9;
}
</style>